document.addEventListener('DOMContentLoaded', function () {
  // Image clicks
  const mainImage = document.getElementById('main-product-image');
  const thumbnailButtons = document.querySelectorAll('.thumbnail-button');
  // Handle thumbnail clicks
  thumbnailButtons.forEach((button) => {
    button.addEventListener('click', function () {
      // Update main image
      mainImage.src = this.dataset.fullUrl;
      mainImage.alt = this.dataset.alt;

      // Update active state of thumbnails
      thumbnailButtons.forEach((btn) => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });

  const form = document.getElementById('product-form');
  if (!form) {
    return;
  }
  const variantSelects = document.querySelectorAll('.variant-selector');
  const variantIdInput = form.querySelector('input[name="id"]');

  // Parse the variants JSON
  const variantsJson = document.getElementById(`ProductJson-${form.dataset.productId}`);
  const variants = JSON.parse(variantsJson.textContent);

  // Create a map of variant combinations
  const variantMap = variants.reduce((map, variant) => {
    const key = variant.options.join(' / ');
    map[key] = variant.id;
    return map;
  }, {});

  function updateVariantId() {
    const selectedOptions = [];
    document.querySelectorAll('.variant-selector:checked').forEach((select) => {
      selectedOptions.push(select.value);
      // selectedOptions[parseInt(select.dataset.optionIndex)] = select.value;
    });

    const variantKey = selectedOptions.join(' / ');
    const variantId = variantMap[variantKey];

    if (variantId) {
      variantIdInput.value = variantId;
      const variant = variants.find((v) => v.id === variantId);

      // Update price, availability, etc.
      if (variant) {
        // Update price
        const priceElement = document.querySelector('.product-price');
        if (priceElement) {
          const symbol = priceElement.dataset.currencySymbol;
          priceElement.textContent = symbol + parseFloat((variant.price / 100).toFixed(2)).toLocaleString();
        }

        // Update availability
        const addButton = form.querySelector('button[type="submit"]');
        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add to cart';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      }
    }
  }

  // Listen for changes on variant selectors
  variantSelects.forEach((select) => {
    select.addEventListener('change', updateVariantId);
  });

  // Handle form submission
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const variantId = variantIdInput.value;
    const quantity = parseInt(form.querySelector('input[name="quantity"]').value);

    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        submitButton.textContent = 'Added to cart!';

        // Update cart count
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            const cartCount = document.querySelector('.cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
          });

        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = 'Add to cart';
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        submitButton.textContent = 'Error - Try Again';
        submitButton.disabled = false;
      });
  });

  // Initialize variant selection
  updateVariantId();
});
